'use strict';
import { MxDialogViewComponent } from './dialog-view/dialog-view.component';
import { DialogFactory } from './dialog-factory';
import { MxDialogContentComponent } from './dialog-content/dialog-content';
import { MxDialogContainerComponent } from './mx-dialog-container/mx-dialog-container';
import { MxDialogManager } from './mx-dialog-manager/mx-dialog-manager';

export default angular
	.module('mx.sb.DialogView', [
		/*'mx.shell', 'mx.SolutionBuilderAgent'*/
	])
	.component('mxDialogView', MxDialogViewComponent)
	.component('mxCommonDialogContent', MxDialogContentComponent)
	.component('mxDialogContainer', MxDialogContainerComponent)
	.component('mxDialogManager', MxDialogManager)
	.service('mx.sb.DialogView.DialogFactory', DialogFactory).name;
